import { Outlet, createBrowserRouter } from 'react-router';
import { Error404, Loader } from 'ui-components';
import React from 'react';
import { BookingLayout } from 'booking/components';
import { SalonList } from 'controlled-components';
import {
  BookingDetailsByUid,
  NewBooking,
  NewPassPurchase,
  PassDetailsByUid,
  PassPurchaseError,
  Passes,
} from './routes';

export default createBrowserRouter([
  {
    element: (
      <BookingLayout src="/images/manual-booking-bg.jpg">
        <React.Suspense fallback={<Loader />}>
          <Outlet />
        </React.Suspense>
      </BookingLayout>
    ),
    children: [
      {
        path: '/:slug',
        element: <NewBooking />,
      },
      {
        path: '/booking/:uid',
        element: <BookingDetailsByUid />,
      },
      {
        path: '/:slug/passes',
        element: <Passes />,
      },
      {
        path: '/:slug/passes/:passId/purchase',
        element: <NewPassPurchase />,
      },
      {
        path: '/:slug/pass/:uid',
        element: <PassDetailsByUid />,
      },
      {
        path: '/passes/payment-error/:transactionId',
        element: <PassPurchaseError />,
      },
    ],
  },
  {
    path: '/',
    element: <SalonList />,
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
